import React, { useRef,useEffect } from "react";
import "./App.css";
import { Route, Switch, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import "./assets/css/bootstrap.min.css";
import "./assets/css/animate.css";
import "./assets/css/bootsnav.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/css/custom.css";

//import './assets/css/App.scss';

import Footer from "./component/include/Footer";
import Login from "./component/Login";
import Forgot from "./component/Forgot";
import Registration from "./component/Registration";
import Home from "./component/Home";
import Home_Mob from "./component/Home_Mob";

import Dashboard from "./component/Dashboard";
import Findauction from "./component/Findauction";

import Addauction from "./component/auction/Addauction";

import Auctiondetail from "./component/auction/Auctiondetail";
import JoinauctionCode from "./component/auction/JoinauctionCode";
import JoinauctionCode2 from "./component/auction/JoinauctionCode2";
import JoinauctionCode3 from "./component/auction/JoinauctionCode3";
import Joinauction from "./component/auction/Joinauction";
import JoinauctionCustomization from "./component/auction/JoinauctionCustomization";
import Myauction from "./component/auction/Myauction";
import Editauction from "./component/auction/Editauction";

import Addcategory from "./component/category/Addcategory";
import Category from "./component/category/Category";
import Editcategory from "./component/category/Editcategory";

import Addplayers from "./component/players/Addplayers";
import Newaddplayer from "./component/players/Newaddplayer";
import Editplayers from "./component/players/Editplayers";
import Players from "./component/players/Players";
import Players_new from "./component/players/Players_new";
import Playerspdf from "./component/players/Playerspdf";

import Addteam from "./component/team/Addteam";
import Addteam2 from "./component/team/Team2";
import Editteam from "./component/team/Editteam";
import Team from "./component/team/Team";

import Profile from "./component/profile/Myprofile";
import EditProfile from "./component/profile/EditProfile";
import ChangePassword from "./component/profile/ChangePassword";

import TodayAuction from "./component/pages/TodayAuction";
import UpcomingAuction from "./component/pages/UpcomingAuction";
import AboutUs from "./component/pages/About";

import Logout from "./component/Logout";
import Error from "./component/Error";
// import { Detector } from "react-detect-offline";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./component/include/Header";
import Navigationtitle from "./component/include/Navigationtitle";
import { Col, Row } from "react-bootstrap";
import DashboardSidebar from "./component/DashboardSidebar/dashboardSidebar";
import { getDatabase, ref, remove, onValue, set, update } from "firebase/database";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useSelector, useDispatch } from "react-redux";
import Importplayers from "./component/players/Importplayers";
import Joinsuccess from "./component/auction/Joinsuccess";
import AuctionPayment from "./component/auction/AuctionPayment";
import AuctionCustomization from "./component/auction/AuctionCustomization";
import AuctionCustomization_new from "./component/auction/AuctionCustomization_new";
import OverlayCustomization from "./component/auction/OverlayCustomization";
import SpecProvider from "./component/auction/SpecContext.jsx";
// import { setupdtoken } from "./actions/index";

function App() {
  const location = useLocation();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const firebaseConfig = {
    apiKey: "AIzaSyAiZfDIylsaUIB5xfQOdlC6qKaxUxlMl3g",
    authDomain: "jain-cricket-league.firebaseapp.com",
    databaseURL: "https://jain-cricket-league.firebaseio.com",
    projectId: "jain-cricket-league",
    storageBucket: "jain-cricket-league.appspot.com",
    messagingSenderId: "886224719584",
    appId: "1:886224719584:web:be3d8efa9acf1b23cd0a85"
  };
  const app = initializeApp(firebaseConfig);
 
  const auth = getAuth();
  // const handlelogin=()=>{
    signInWithEmailAndPassword(auth, 'spa2@gmail.com', 'qL99rkB9JIZ5gfBdrtTLyiZnhyO3')
    .then((userCredential) => {
      // Signed in 
      const user = userCredential.user;
      // //  console.log(user)  
      //  console.log("logged in")
      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
    });
  // }
  const dispatch = useDispatch();

  
  useEffect(() => {
    // const token = generateToken(10);
    // //  console.log("token set :" + token)
    // dispatch(setupdtoken(token));

  }, []);

  return (
    <>
    
      {/* <Detector
        style={{ display: "none" }}
        render={({ online }) => (
          <div className={online ? "net-online" : "net-offline"}>
            {online ? "" : "Network Problem"}
          </div>
        )}
      /> */}
      {location.pathname !== '/join-auction-code3' && location.pathname !== '/join-auction-success' && <Header />}
      {/* <Row className="marginTop-24px">
        <Col lg={3}>
          <DashboardSidebar />
        </Col>
        <Col lg={9}>
          {" "} */}
      <ToastContainer hideProgressBar={true} />
      <Switch>
        {/* <Route
          exact
          path="/"
          component={() =>
            isTabletOrMobile || isPortrait ? (
              <Home_Mob title="Login" />
            ) : (
              <Home title="Login" />
            )
          }
        /> */}
        <Route
          exact
          path="/"
          component={() => <Login title="Login" />}
        />
        <Route
          exact
          path="/forgotPassword"
          component={() => <Forgot title="Forgot" />}
        />

        <Route
          exact
          path="/user-registration"
          component={() => <Registration title="Registration" />}
        />

        <Route
          exact
          path="/Logout"
          component={() => <Logout title="Logout" />}
        />

        {/* Full width route for join-auction-code3 - outside sidebar layout */}
        <Route
          exact
          path="/join-auction-code3"
          component={() => <JoinauctionCode3 title="Join auction" />}
        />

        {/* Full width route for join-auction-success - outside sidebar layout */}
        <Route
          exact
          path="/join-auction-success"
          component={() => <Joinsuccess title="Join auction" />}
        />

        <Row className="background-color-sidebar-container">
          <Col lg={3}>
            {isTabletOrMobile || isPortrait ? null : <DashboardSidebar />}
          </Col>
          <Col lg={9}>
            <Route
              exact
              path="/today-auction"
              component={() => (
                <TodayAuction
                  navigationBar="1"
                  loginStatus={false}
                  active_link="today-auction"
                  title="Today Auction"
                />
              )}
            />
            <Route
              exact
              path="/upcoming-auction"
              component={() => (
                <UpcomingAuction
                  navigationBar="1"
                  loginStatus={false}
                  active_link="upcoming-auction"
                  title="Upcoming Auction"
                />
              )}
            />

            <Route
              exact
              path="/Dashboard"
              component={() => (
                <Dashboard title="Dashboard" bpath="/Dashboard" bpathtype="" />
              )}
            />
            <Route
              exact
              path="/about-us"
              component={() => (
                <AboutUs
                  title="About Us"
                  loginStatus={false}
                  navigationBar="1"
                  bpath=""
                  bpathtype=""
                />
              )}
            />

            <Route
              exact
              path="/new-auction"
              component={() => <Addauction title="Create Auction" />}
            />
            <Route
              exact
              path="/auction-detail"
              component={() => <Auctiondetail title="Auction Detail" />}
            />
            <Route
              exact
              path="/join-auction"
              component={() => <Joinauction title="Join auction" />}
            />
            <SpecProvider>
            <Route
              exact 
              path="/join-auction-customization"
              component={() => <JoinauctionCustomization title="Join auction customization" />}
            />
            </SpecProvider>
            <Route
              exact
              path="/auction-customization2"
              component={() => <AuctionCustomization_new  />}
            />
            <Route
              exact
              path="/auction-customization"
              component={() => <AuctionCustomization  />}
            />
            <Route
              exact
              path="/overlay-customization" 
              component={() => <OverlayCustomization  />}
            />
            <Route
              exact
              path="/join-auction-code"
              component={() => <JoinauctionCode title="Join auction" />}
            />
            <Route
              exact
              path="/join-auction-code2"
              component={() => <JoinauctionCode2 title="Join auction" />}
            />

            <Route
              exact
              path="/auction-payment"
              component={() => <AuctionPayment title="Auction Payment" />}
            />
            <Route
              exact
              path="/my-auction"
              component={() => (
                <Myauction
                  title="My auction"
                  bpath=""
                  bpathtype=""
                  link_data="new-auction"
                  link="add"
                />
              )}
            />
            <Route
              exact
              path="/edit-auction/:aid"
              component={() => (
                <Editauction
                  title="Edit auction"
                  bpath="2"
                  bpathtype=""
                  link="back"
                />
              )}
            />

            <Route
              exact
              path="/add-auction-category"
              component={() => (
                <Addcategory
                  title="Create category"
                  bpath="3"
                  bpathtype="2"
                  link=""
                />
              )}
            />
            <Route
              exact
              path="/auction-category"
              component={() => (
                <Category
                  title="Category"
                  bpath="2"
                  bpathtype="2"
                  link_data="add-auction-category"
                  link="add,reload"
                />
              )}
            />
            <Route
              exact
              path="/edit-auction-category/:ctid"
              component={() => (
                <Editcategory
                  title="Edit Category"
                  bpath="3"
                  bpathtype="2"
                  link=""
                />
              )}
            />

            <Route
              exact
              path="/add-auction-player"
              component={() => (
                <Addplayers
                  title="Add players"
                  bpath="3"
                  bpathtype="3"
                  link=""
                />
              )}
            />
            <Route
              exact
              path="/newplayerform"
              component={() => (
                <Newaddplayer
                  title="New form"
                  bpath="3"
                  bpathtype="3"
                  link=""
                />
              )}
            />
            <Route
              exact
              path="/players-pdf"
              component={() => (
                <Playerspdf/>
              )}
            />
            <Route
              exact
              path="/import-players"
              component={() => (
                <Importplayers 
                title="Import Players"
                // link="add,reload"
                />
              )}
            />
            <Route
              exact
              path="/auction-players"
              component={() => (
                <Players
                  title="Players"
                  bpath="2"
                  bpathtype="3"
                  link_data="add-auction-player"
                  link="add,reload"
                />
              )}
            />
            <Route
              exact
              path="/auction-players2"
              component={() => (
                <Players_new
                  title="Players"
                  bpath="2"
                  bpathtype="3"
                  link_data="add-auction-player"
                  link="add,reload"
                />
              )}
            />
            <Route
              exact
              path="/edit-auction-player/:pid"
              component={() => (
                <Editplayers
                  title="Edit players"
                  bpath="3"
                  bpathtype="3"
                  link=""
                />
              )}
            />

            <Route
              exact
              path="/add-auction-team"
              component={() => (
                <Addteam title="Create team" bpath="3" bpathtype="1" link="" />
              )}
            />
            <Route
              exact
              path="/add-auction-team2"
              component={() => (
                <Addteam2 title="Create team" bpath="3" bpathtype="1" link="" />
              )}
            />
            <Route
              exact
              path="/edit-auction-team/:tid"
              component={() => (
                <Editteam title="Edit team" bpath="3" bpathtype="1" link="" />
              )}
            />
            <Route
              exact
              path="/auction-team"
              component={() => (
                <Team
                  title="Team"
                  bpath="2"
                  bpathtype="3"
                  link_data="add-auction-team"
                  link="add,reload"
                />
              )}
            />

            <Route
              exact
              path="/find-auction"
              component={() => <Findauction title="Find Auction" />}
            />
            <Route
              exact
              path="/my-profile"
              component={() => (
                <Profile title="My Profile" bpath="" bpathtype="" />
              )}
            />
            <Route
              exact
              path="/edit-profile"
              component={() => (
                <EditProfile title="Edit Profile" bpath="3" bpathtype="4" />
              )}
            />
            <Route
              exact
              path="/change-password"
              component={() => (
                <ChangePassword
                  title="Change Password"
                  bpath="3"
                  bpathtype="4"
                />
              )}
            />
          </Col>
        </Row>

        <Route component={Error} />
      </Switch>
      {/* </Col>
      </Row> */}
      {/* <Navigationtitle /> */}

      <Footer />
      
    </>
  );
}

export default App;
